import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-my-profile-section',
  templateUrl: './my-profile-section.component.html',
  styleUrls: ['./my-profile-section.component.scss']
})
export class MyProfileSectionComponent implements OnInit {

  isLoading = true;
  currentUser;
  nameInput = '';
  isUploadingFile = false;
  isEditInfo = false;
  isEditExtra = false;
  inputDate: Date;

  constructor(
    protected userService: UserService
  ) { }

  ngOnInit(): void {
    this.loadUser();
  }

  loadUser() {
    this.userService.fetchProfile().subscribe(data => {
      if (data.success) {
        this.currentUser = data.response;
        this.nameInput = this.currentUser.firstname + " " + this.currentUser.lastname;
      }
    });
  }
}
